module.exports = "{{#list}}\n  <li data-id=\"{{data}}\" {{#selected}}class=\"selected\"{{/selected}}>{{label}}</li>\n{{/list}}"